import React, { useEffect, useState } from 'react';
import SearchableDropdown, { DropdownOption } from '../../../_common/SearchableDropdown/SearchableDropdown';
import {
    AssetInfoType,
    GetEquipmentsInfo_getEquipmentsInfo as EquipmentsInfo,
} from '../../../../types/schemaTypes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface AssetInfoToSaveProps {
    index: number;
    assetTypeId: number | null;
    assetType: string | null;
    assetId: number | null;
    assetDescrip: string | null;
    quantity: number | null;
}

interface AddEquipmentsDetailsRowProps {
    index: number;
    asset?: AssetInfoType;
    asssetTypes: DropdownOption[];
    assetInfoToSave: AssetInfoToSaveProps[] | undefined;
    setAssetInfoToSave: React.Dispatch<React.SetStateAction<AssetInfoToSaveProps[] | undefined>>;
    equipmentsInfo: EquipmentsInfo | undefined;
    updatePaycode: () => void;
    loading: boolean;
    isEditable: boolean;
    disableEquipmentIdSelection?: boolean;
}

const AddEquipmentsDetailsRow = ({
    index,
    asset,
    asssetTypes,
    assetInfoToSave,
    setAssetInfoToSave,
    equipmentsInfo,
    updatePaycode,
    loading,
    isEditable,
    disableEquipmentIdSelection = false,
}: AddEquipmentsDetailsRowProps): React.ReactElement => {
    const searchIcon = <FontAwesomeIcon icon={{ prefix: 'fas', iconName: 'search' }} />;
    const [isDeleted, setIsDeleted] = useState(false);

    const [assetType, setAssetType] = useState(asset?.assetType ?? '');
    const [assetDescrip, setAssetDescrip] = useState(asset?.assetDescrip ?? '');
    const [quantity, setQuantity] = useState(asset?.quantity ?? '');

    useEffect(() => {
        if (asset && assetType === '') {
            setAssetType(asset.assetType ?? '');
            setAssetDescrip(asset.assetDescrip ?? '');
            setQuantity(asset.quantity ?? '');
        }
    }, [asset]);

    const savedRow = assetInfoToSave?.find((i) => i.index === index);
    useEffect(() => {
        if (!savedRow) return;
        setAssetDescrip(savedRow.assetDescrip ?? '');
    }, [savedRow?.assetDescrip, savedRow?.assetId, index]);

    const [error, setError] = useState('');

    const equipmentDescripList: DropdownOption[] = [];
    if (equipmentsInfo) {
        const key = assetType.toLowerCase().replaceAll(' ', '');
        equipmentsInfo[key]?.map(item => {
            equipmentDescripList.push({
                id: item.itemId,
                name: item.descrip,
            })
        });
    }

    if (!isDeleted) {
        let exists = false;
        assetInfoToSave?.map(assetInfo => {
            if (assetInfo.index === index)
                exists = true;
        })
        if (!exists) {
            let tempAssetInfoToSave: AssetInfoToSaveProps[] = [];
            if (assetInfoToSave) tempAssetInfoToSave = [...assetInfoToSave];
            tempAssetInfoToSave?.push({
                index: index,
                assetType: null,
                assetTypeId: null,
                assetId: null,
                assetDescrip: '',
                quantity: null,
            });
            setAssetInfoToSave(tempAssetInfoToSave);
        }
    }

    const updateAssetInfo = (inputType: string, value: any) => {
        if (assetInfoToSave) {
            const tempAssetInfoToSave = [...assetInfoToSave];
            tempAssetInfoToSave.map(item => {
                if (item.index === index) {
                    item[inputType] = value;
                }
            })
            setAssetInfoToSave(tempAssetInfoToSave);
        }
    }

    const handleOnChangeAssetType = (assetTypeId: number) => {
        setError('');
        let assetType = '';
        asssetTypes.map(item => {
            if (assetTypeId === item.id)
                assetType = item.name.toString();
        })
        setAssetType(assetType);
        updateAssetInfo('assetTypeId', assetTypeId);
        updateAssetInfo('assetType', assetType);

        setQuantity(1);
        updateAssetInfo('quantity', 1);

        setAssetDescrip(' ');
        updateAssetInfo('assetId', null);
        updateAssetInfo('assetDescrip', '');

        let isSelected = false;
        assetInfoToSave?.map(assetInfo => {
            if (assetInfo.index !== index && assetInfo.assetType === assetType && assetInfo.assetDescrip === assetDescrip && assetDescrip.length !== 0)
                isSelected = true
        })
        if (isSelected)
            setError('This equipment is already added');

        updatePaycode();
    }

    const handleOnChangeAssetDescrip = (assetDescripId: number) => {
        setError('');
        let assetDescrip = '';
        equipmentDescripList.map(item => {
            if (assetDescripId === item.id)
                assetDescrip = item.name.toString();
        })
        setAssetDescrip(assetDescrip);
        updateAssetInfo('assetId', assetDescripId);
        updateAssetInfo('assetDescrip', assetDescrip);

        let isSelected = false;
        assetInfoToSave?.map(assetInfo => {
            if (assetInfo.index !== index && assetInfo.assetType === assetType && assetInfo.assetDescrip === assetDescrip && assetDescrip.length !== 0)
                isSelected = true
        })
        if (isSelected)
            setError('This equipment is already added');

        updatePaycode();
    }

    const handleOnChangeQuantity = (quantity: number) => {
        if (quantity < 1) return;
        setQuantity(quantity);
        updateAssetInfo('quantity', quantity);
    }

    const handleOnClickRemoveEquipment = () => {
        if (assetInfoToSave) {
            const tempAssetInfoToSave = [...assetInfoToSave];
            const tempAssetInfoToSave2 = tempAssetInfoToSave?.filter(asset => {
                if (asset.index !== index) return asset;
            });
            setAssetInfoToSave(tempAssetInfoToSave2);
            setIsDeleted(true);
        }
    };

    if (isDeleted) {
        return <></>;
    }

    if (!isEditable) {
        return (
            <tr key={index}>
                <td className='AddAssetDetails-Dropdown'>
                    {assetType}
                </td>
                <td>
                    {quantity}
                </td>
                <td className="AddAssetDetails-Dropdown">
                    {assetDescrip}
                </td>
                <td></td>
            </tr>
        )
    }

    return (
        <tr key={index}>
            <td className='AddAssetDetails-Dropdown'>
                <SearchableDropdown
                    dropdownOptions={asssetTypes}
                    id="equipmentType"
                    label=""
                    onSelect={value => { value && handleOnChangeAssetType(parseInt(value)) }}
                    value={assetType}
                />
            </td>
            <td>
                {["Mats", "Forklift Ramp", "Miscellaneous"].includes(assetType) ?
                    <input type='number'
                        className="AddAssetDetails-Number AddAssetDetails-Row-Number"
                        value={quantity}
                        onChange={(event) => handleOnChangeQuantity(parseInt(event.target.value))}
                    /> : <>{quantity}</>
                }
            </td>
            <td className="AddAssetDetails-Dropdown">
                {["Mats", "Forklift Ramp", "Miscellaneous"].includes(assetType) || !assetType ?
                    <></> : <SearchableDropdown
                        dropdownOptions={equipmentDescripList}
                        id="equipmentDescrip"
                        label=""
                        onSelect={value => { value && handleOnChangeAssetDescrip(parseInt(value)) }}
                        value={assetDescrip}
                        autoCompleteEnabled
                        endIcon={searchIcon}
                        disabled={loading || disableEquipmentIdSelection}
                    />
                }
                <span className="AddAssetDetails-Error">{error}</span>
            </td>
            <td><button className='AddAssetDetails-Action-Button' onClick={handleOnClickRemoveEquipment}>Remove</button></td>
        </tr>
    )
}

export default AddEquipmentsDetailsRow;